import React from 'react';
import {useTranslation} from 'react-i18next';
import {CaretRight} from '@phosphor-icons/react';
import {useOnboardingProgress} from './useOnboardingProgress';
import {useHelpDrawer} from './HelpDrawerContext';

/**
 * "Dashbo Setup" progress tile rendered directly below the Ayuda link in the
 * sidebar. Clicking it opens the HelpDrawer. Hides itself at 100%.
 */
export function MiniOnboardingBar() {
    const {t} = useTranslation();
    const {openDrawer} = useHelpDrawer();
    const {steps, completedCount, totalCount, allCompleted} = useOnboardingProgress();

    if (allCompleted) return null;

    return (
        <button
            type="button"
            className="sidebar-v2-mini-onboarding"
            onClick={() => openDrawer('basic')}
            title={t('help.dashbo_setup')}
            aria-label={`${t('help.dashbo_setup')} · ${completedCount}/${totalCount}`}
        >
            <span className="sidebar-v2-mini-onboarding-header">
                <span className="sidebar-v2-mini-onboarding-copy">
                    <span className="sidebar-v2-mini-onboarding-title-row">
                        <span className="sidebar-v2-mini-onboarding-title">{t('help.dashbo_setup')}</span>
                        <span className="sidebar-v2-mini-onboarding-step-count">{completedCount}/{totalCount}</span>
                    </span>
                    <span className="sidebar-v2-mini-onboarding-description">
                        {t('help.mini_bar_description')}
                    </span>
                </span>
            </span>

            <span className="sidebar-v2-mini-onboarding-lines">
                {steps.map(step => (
                    <span
                        key={step.key}
                        className={`sidebar-v2-mini-onboarding-line${step.completed ? ' -completed' : ''}`}
                    >
                        <span className="sidebar-v2-mini-onboarding-tooltip">
                            {t(step.labelKey)}
                        </span>
                    </span>
                ))}
            </span>

            <span className="sidebar-v2-mini-onboarding-arrow" aria-hidden="true">
                <CaretRight size={18} weight="bold"/>
            </span>
        </button>
    );
}

export default MiniOnboardingBar;
